import React, { Component } from "react";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import FullLoader from "./../components/FullLoader";
import { authenticateUser } from "./../actions/authAction";
import queryString from "query-string";

class ProtectedRoute extends Component {
  componentDidMount() {
    // let salt, sid;
    let url = encodeURIComponent(window.location);
    let { sid, salt } = queryString.parse(this.props.location.search);
    if (sid && salt) {
      sid = queryString.parse(this.props.location.search).sid;
      salt = queryString.parse(this.props.location.search).salt;
      localStorage.setItem("sid", sid);
      localStorage.setItem("salt", salt);
    } else {
      if (localStorage.getItem("sid") && localStorage.getItem("salt")) {
        sid = localStorage.getItem("sid");
        salt = localStorage.getItem("salt");
      } else {
        salt = process.env.REACT_APP_SSO_SALT;
      }
    }
    this.props.authenticateUser(salt, sid, url);
  }

  render() {
    const { component: Component, is_authenticated, ...rest } = this.props;
    return is_authenticated ? (
      <Route {...rest} render={(props) => <Component {...props} />} />
    ) : (
      <FullLoader />
    );
  }
}

const mapStateToProps = (store) => {
  return {
    is_authenticated: store.authReducer.is_authenticated,
  };
};

export default connect(mapStateToProps, { authenticateUser })(ProtectedRoute);
